import { SkeletonLoader } from '@design/components/skeleton-loader/SkeletonLoader';
import { DrawerContentWrapper } from '@terminal/components/drawer-content-wrapper/DrawerContentWrapper';
import { ErrorBoundaryWrapper } from '@terminal/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { ErrorMessageWrapper } from '@terminal/components/error-message-wrapper/ErrorMessageWrapper';
import { useGetInsightWidgetData } from '@terminal/services/insights/insights-service';
import { ScheduleDemoBanner } from '@terminal/views/insight-feed/components/schedule-demo-banner/ScheduleDemoBanner';
import React from 'react';

import { InsightDrawerCategoryRow } from './InsightDrawerCategoryRow';
import { InsightsDrawerContent } from './InsightsDrawerContent';
import styles from './ScenarioInsightWidget.module.scss';

interface InsightsDrawerWidgetProps {
  insightId: string;
  contentWrapperRef: React.Ref<HTMLDivElement>;
}

export const ScenarioInsightWidget = ({
  insightId,
  contentWrapperRef,
}: InsightsDrawerWidgetProps) => {
  const { data, isLoading } = useGetInsightWidgetData(insightId);

  if (isLoading) {
    return (
      <SkeletonLoader
        className={styles.loadingSkeletonWrapper}
        areas={[
          { styles: { width: '100%', height: '72px', borderRadius: '8px' } },
          { styles: { width: '100%', height: '275px', borderRadius: '8px' } },
          { styles: { width: '100%', height: '400px', borderRadius: '8px' } },
          { styles: { width: '100%', height: '400px', borderRadius: '8px' } },
        ]}
      />
    );
  }

  if (data?.error || !data?.data) {
    return (
      <ErrorMessageWrapper variant="empty" className={styles.errorWrapper} />
    );
  }

  const { insight } = data.data;

  return (
    <DrawerContentWrapper>
      <div ref={contentWrapperRef}>
        <ErrorBoundaryWrapper>
          <InsightsDrawerContent
            insightsData={data.data}
            header={() => (
              <div>
                <InsightDrawerCategoryRow insight={insight} />
                <div className={styles.title}>
                  {insight?.simple_title ?? insight.card.name}
                </div>
              </div>
            )}
          />
        </ErrorBoundaryWrapper>
        <ScheduleDemoBanner />
      </div>
    </DrawerContentWrapper>
  );
};
